var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"productDetails"},[_c('div',{staticClass:"reportBasic-subTitle"},[_vm._v("\n    "+_vm._s(_vm.$tc('lang.ReportsDetail.Product_Details'))+"\n  ")]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.ReportsDetail.Front')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.productProcess.front,"otherData":{
          mediaName: '',
          mediaType: '',
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: '',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.ReportsDetail.Side')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.productProcess.side,"otherData":{
          mediaName: '',
          mediaType: '',
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: '',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.ReportsDetail.PACKING_INFORMATION')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.productProcess.back,"otherData":{
          mediaName: '',
          mediaType: '',
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: '',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.ReportsDetail.Inside')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.productProcess.inside,"otherData":{
          mediaName: '',
          mediaType: '',
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: '',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.ReportsDetail.Details')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.productProcess.printdetail,"otherData":{
          mediaName: '',
          mediaType: '',
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: '',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.ReportsDetail.Product_Measurements')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.productProcess.productsize,"otherData":{
          mediaName: '',
          mediaType: '',
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: '',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.ReportsDetail.Contrastphoto')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.productProcess.contrastphoto,"otherData":{
          mediaName: '',
          mediaType: '',
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: '',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-table"},[_c('a-table',{staticClass:"desOfGoods-table2",attrs:{"columns":_vm.columns,"dataSource":_vm.data,"bordered":"","pagination":false,"rowKey":"id"}}),_c('a-table',{staticClass:"desOfGoods-table3",attrs:{"columns":_vm.columns1,"dataSource":_vm.data1,"bordered":"","scroll":{ y: 200 },"pagination":false,"rowKey":"id"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }